import React from "react";
import { Card, Avatar, Space, Typography } from "antd";
import { ReactComponent as IsoLogo } from "../../../Navbar/assets/iso-nav.svg"

const { Title, Text, Paragraph } = Typography;

const CompanyCard = ({ licence }) => (
  <Card title="Empresa" bordered={false} className="licences-card">
    <Space
      direction="vertical"
      align="center"
      size="middle"
      style={{ width: "100%" }}
    >
      <Avatar
        size={80}
        className="licences-company-avatar"
        icon={<IsoLogo className="company-logo" />}
      />
      <Title level={4} className="licences-company-title">
        {licence.tenant_name || "N/A"}
      </Title>
      <div className="licences-contact-text">
        <Text strong>Contacto Principal</Text>
        <Paragraph type="secondary" copyable>
          {licence.principal_email || "N/A"}
        </Paragraph>
        <Text strong>Contacto Administrativo</Text>
        <Paragraph type="secondary" copyable>
          {licence.admin_email || "N/A"}
        </Paragraph>
      </div>
    </Space>
  </Card>
);

export default CompanyCard;